export function Splash({ text = 'Načítám…' }: { text?: string }) {
  return (
    <div className="splash" role="status">
      <span>{text}</span>
    </div>
  );
}

export function InvalidLink({ text }: { text?: string }) {
  return (
    <div className="center-page">
      <h1>Odkaz nefunguje</h1>
      <p className="muted">
        {text ?? 'Odkaz je neplatný nebo ho správce zneplatnil. Požádej o nový.'}
      </p>
    </div>
  );
}
